/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, HostBinding } from '@angular/core';

import { ActionModel } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'button[kitModel]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent extends BaseDirective<ActionModel> {

  @HostBinding('class.kit-loading')
  get isLoading(): boolean {
    return this.model && this.model.isLoading;
  }

  get hostClass(): string {
    return 'kit-button';
  }

}
